import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { createTheme, ThemeProvider, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonthRounded';

const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            "&.MuiInputBase-input": {
              fontFamily: "Roboto medium, Helvetica, Arial, sans-serif",
              fontSize: "14px",
              fontWeight: '500'
            },
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            "&.MuiTypography-root": {
              fontFamily: "Roboto regular, Helvetica, Arial, sans-serif",
              fontSize: "14px",
              fontWeight: '400'
            },
          },
        },
      },
    },
});



const MonthPickerCopy = ({tag, value, setValue, width, font,topAlignTypography=false}) => {
        // set width if not passed as prop
        if (width == null){
            width = '16.5vw';
        }
        // set font size if given as prop, else use default
        let style = {};
        if (font){
            style['fontSize'] = font;
        }
    
        // handler to set date on input 
        const handleChange = (newVal) => {
            setValue(value => value = newVal ); 
        }
    
        return (
            // date picker from material ui
            <div className={topAlignTypography? "d-flex flex-column w-100":"d-flex align-items-center gap-3 w-100"}>
                <ThemeProvider theme={theme}>
                    <Typography>
                        {tag}
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker 
                            size = 'small'
                            value={value}
                            onChange={handleChange}
                            inputProps={{style: style}}       
                            renderInput={(params) => <TextField InputLabelProps={{style: style}} sx={{ width: width }} size='small' {...params} />}
                            emptyLabel='None' 
                            views={['month', 'year']} 
                            slotProps={{ textField: { size: 'small' } }}
                            slots={{ 
                                openPickerIcon: () => <CalendarMonthIcon sx={{color: 'black'}}/>
                            }}
                            className='date-class'
                        />
                    </LocalizationProvider>
                </ThemeProvider>
            </div>
        );
}

export default MonthPickerCopy; 